import React, { useEffect } from "react";
import AddNewMember from "./AddNewMembers";
import "./style.scss";

const UserTabs = ({
  selected,
  setSelected,
  setShow,
  user,
  setTypeUser,
  ...props
}) => {
  const user_tabs = [
    {
      title: "Details",
      content: <AddNewMember user={user} setSelecte={setSelected} {...props} />,
    },
    // {
    //   title: "Notes",
    //   content: <>Notes</>,
    // },
  ];
  useEffect(() => {
    setSelected(user_tabs[0].title);
    setShow(user_tabs[0].content);
  }, []);

  useEffect(() => {
    return () => {
      setTypeUser(false);
    };
  }, [user]);

  return (
    <div className="toggle-bar">
      {user_tabs.map((tab, index) => {
        return (
          <p
            key={index}
            className={selected === tab.title ? "selected" : "unselected"}
            onClick={() => {
              setSelected(tab.title);
              setShow(tab.content);
            }}
          >
            <span className="title">{tab.title}</span>
          </p>
        );
      })}
    </div>
  );
};
export default UserTabs;
